import React from 'react';
import { DesktopInboxList, MobileInboxListV2 } from '@/components/dashboard';
import { useSearchParams } from 'next/navigation';
import { GET_INBOX_LIST } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { inboxService } from '@/api/inbox';
import { LoaderScreen } from '@/components/common';
// import { InboxList } from './InboxList';
// import { NewEmail } from './NewEmail';
// import { Card } from '@/components/form';

export const InboxScreen: React.FC = () => {
	// const [openNewEmail, setOpenNewMessage] = React.useState<boolean>(false);

	const searchParams = useSearchParams();
	const params = new URLSearchParams(searchParams);

	const limit = 100;
	const page = params.get('page') ?? 1;
	const search = params.get('search') ?? '';
	const caseId = params.get('caseId') ?? '';

	const {
		data: inbox,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [GET_INBOX_LIST, page, search, caseId],
		queryFn: () =>
			inboxService.getInboxList({
				page: Number(page),
				limit,
				search,
				caseId,
				aiEnabled: true,
			}),
	});

	const inboxCases =
		inbox?.data.items.map((item) => ({
			id: item.id,
			case_name: item.case_name,
			case_id: item.case_id,
			is_read: item.is_read,
		})) || [];

	const onClickRead = async (id: string): Promise<void> => {
		try {
			await inboxService.markConversationRead(id);
			refetch();
		} catch (error) {
			console.log('Error', error);
		}
	};

	return (
		<>
			{/* <LayoutInbox>
				<InboxList setOpenNewMessage={setOpenNewMessage} />
			</LayoutInbox>
			<NewEmail
				openNewMessage={openNewEmail}
				setOpenNewMessage={setOpenNewMessage}
			/> */}

			{isLoading ? (
				<LoaderScreen />
			) : (
				<>
					<DesktopInboxList
						tableData={inboxCases || []}
						markAsRead={onClickRead}
					/>
					<MobileInboxListV2
						tableData={inboxCases || []}
						markAsRead={onClickRead}
					/>
				</>
			)}
		</>
	);
};
